document.addEventListener('DOMContentLoaded', function() {
    var cookieBannerSettingsLinkShort = document.body.querySelector('.cookie-banner-settings-link-short');
    var cookieBannerSettingsLinkLong = document.body.querySelector('.cookie-banner-settings-link-long');
    var cookieBannerCloseButton = document.body.querySelector('.cookie-banner-close-button');
    var cookieBannerForm = document.body.querySelector('.cookie-banner-form');

    if (cookieBannerForm) {
        cookieBannerSettingsLinkShort.onclick = showSettings;
        cookieBannerSettingsLinkLong.onclick = showSettings;
        cookieBannerCloseButton.onclick = hideBar;

        document.addEventListener('click', function (event) {
            if (event.target.classList.contains('cookie-banner-accept-all-button') === true || event.target.classList.contains('cookie-banner-save-button') === true) {
                event.preventDefault();

                hideBar();

                var xhr = new XMLHttpRequest();

                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        var categories = JSON.parse(xhr.responseText);
                        if (typeof dataLayer !== 'undefined') {
                            for (var i = 0; i < categories.length; i++) {
                                dataLayer.push({'event': categories[i]});
                            }
                        }
                    }
                };

                xhr.open('POST', Routing.generate('_frontend_ajax_cookie_banner_post'));
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.send(serializeForm(cookieBannerForm, event.target.classList.contains('cookie-banner-accept-all-button')));
            }
        }, false);
    }
});

function showSettings()
{
    document.body.querySelector('.cookie-banner-overview-categories').style.display = 'none';
    document.body.querySelector('.cookie-banner-settings-link-short-info').style.display = 'none';
    document.body.querySelector('.cookie-banner-settings-link-short').style.display = 'none';
    document.body.querySelector('.cookie-banner-settings-link-long').style.display = 'none';
    document.body.querySelector('.cookie-banner-accept-all-button').style.display = 'none';
    document.body.querySelector('.cookie-banner-reject-button').style.display = 'none';
    document.body.querySelector('.cookie-banner-save-button').style.display = 'block';

    document.body.querySelector('.cookie-banner-form').classList.remove('hidden');
}

function hideBar()
{
    document.body.querySelector('.cookie-banner').classList.add('hidden');
}

function serializeForm(form, forceValue) {
    var serialized = [];

    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];

        if (forceValue === true && (field.type === 'radio' && field.value == '1')) {
            field.checked = true;
        }

        if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');
}
